import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, MessageCircle } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-secondary/60 border-t border-border mt-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 py-20 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <img src="/brand/logo-round.png?v=5" alt="UK Pet Transport" className="h-14 w-14 object-cover rounded-full border border-border" />
              <span className="font-display text-2xl font-medium">UK PetTransport</span>
            </div>
            <p className="text-muted-foreground text-sm leading-relaxed max-w-md">
              Door-to-door pet courier across the United Kingdom and Europe. Climate-controlled vehicles,
              certified handlers, transparent all-inclusive pricing.
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-xs uppercase tracking-[0.2em] text-muted-foreground font-semibold mb-5">Service</h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/quote" className="hover:text-primary text-foreground/80">Quick Quote</Link></li>
              <li><Link to="/book" className="hover:text-primary text-foreground/80">Book Online</Link></li>
              <li><Link to="/routes" className="hover:text-primary text-foreground/80">All Routes</Link></li>
              <li><Link to="/blog" className="hover:text-primary text-foreground/80">Blog &amp; Journal</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-xs uppercase tracking-[0.2em] text-muted-foreground font-semibold mb-5">Contact</h4>
            <ul className="space-y-3 text-sm text-foreground/80">
              <li className="flex items-center gap-3"><Mail size={16} /> uktranspet@gmail.com</li>
              <li className="flex items-center gap-3"><Phone size={16} /> +44 7784 682148</li>
              <li className="flex items-center gap-3">
                <MessageCircle size={16} />
                <a
                  href="https://wa.me/447784682148?text=Hi%21%20I%27d%20like%20to%20ask%20about%20pet%20transport."
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-primary"
                  data-testid="footer-whatsapp-link"
                >
                  WhatsApp us
                </a>
              </li>
              <li className="flex items-center gap-3"><MapPin size={16} /> United Kingdom · Europe</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-border mt-16 pt-8 flex flex-col md:flex-row justify-between gap-4 text-xs text-muted-foreground">
          <p>© {new Date().getFullYear()} UK Pet Transport. All rights reserved.</p>
          <p>Door-to-door · UK · Europe</p>
        </div>
      </div>
    </footer>
  );
}
